// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "_assets/" + chunkId + "." + {"218":"82bf066a8010ac9ae7de","222":"c7a896ff33ee94b70633"}[chunkId] + ".js";
};